import api from '../../api/indicatorsResultsRoutes.js';

const namespaced = true
 
const state = {
    indicatorsResults: [],
    loadingResults: true,
    startDate: null,
    endDate: null,
    dateResults: [],
    loadingDateResults: true,
}

const mutations = {
    MUTATION_SET_INDICATORS_RESULTS(state, data) {
        state.indicatorsResults = data.data;
        state.loadingResults = false;
    },
    MUTATION_SET_DATE_RESULTS(state, data) {
        state.dateResults = data.data;
        state.loadingDateResults = false;
    },
    MUTATION_ADD_INDICATORS_RESULTS(state, value) {
        state.indicatorsResults.push(value);
    },
    MUTATION_UPSERT_INDICATORS_RESULTS(state, values) {
        values.forEach(value => {
            const index = state.indicatorsResults.findIndex(
                r =>
                r.DepartmentIndicator.id === value.DepartmentIndicator.id &&
                r.fecha === value.fecha
            );
            if (index !== -1) {
                state.indicatorsResults.splice(index, 1, value);
            } else {
                state.indicatorsResults.push(value);
            }
        });

    },
    MUTATION_UPDATE_INDICATORS_RESULTS(state, value) {
        const index = state.indicatorsResults.findIndex(
            ind => ind.id === value.id
        );

        if (index !== -1) {
            state.indicatorsResults.splice(index, 1, value);
        }
    },
    MUTATION_DELETE_INDICATORS_RESULTS(state, value) {
        state.indicatorsResults = state.indicatorsResults.filter(ind => ind.id !== value);
    },
    MUTATION_SET_DATES_INDICATORS_RESULTS(state,value){
        state.startDate = value[0];
        state.endDate = value[1];
    },
}

const actions = {
    getResults(context, id) {
        state.loadingResults = true;
        return new Promise((resolve, reject) => {
            api.getResults(id).then(function (resp) {
                if (resp.status === 200) {
                    context.commit('MUTATION_SET_INDICATORS_RESULTS', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al obtener indicadores'));
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    getDateResults(context, { id, fecha }) {
        state.loadingDateResults = true;
        return new Promise((resolve, reject) => {
            api.getDateResults({ id, fecha }).then(function (resp) {
                if (resp.status === 200) {
                    context.commit('MUTATION_SET_DATE_RESULTS', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al obtener indicadores'));
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    store(context, data){
        return new Promise((resolve, reject) => {
            api.store(data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_ADD_INDICATORS_RESULTS', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al crear'));
                }
            }).catch((error) => {
                reject(error)
            })
        });
    },
    upsert(context, data){
        return new Promise((resolve, reject) => {
            api.upsert(data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_UPSERT_INDICATORS_RESULTS', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al crear'));
                }
            }).catch((error) => {
                reject(error)
            })
        });
    },
    update(context, {id, data}){
        return new Promise((resolve, reject) => {
            api.update(id, data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_UPDATE_INDICATORS_RESULTS', resp.data);
                    resolve(resp.data);
                } else {
                    console.log(resp.data.message);
                    reject(new Error(resp.data?.message || 'Error al actualizar'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete(context, id){
        return new Promise((resolve, reject) => {
            api.deleteResult(id).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_DELETE_INDICATORS_RESULTS', id);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al eliminar'));
                }
            }).catch((error) => {
                reject(error)
            })
        });
    },    
    setDates(context, data){
        context.commit('MUTATION_SET_DATES_INDICATORS_RESULTS', data);
    },    
}

const getters = {
    getresults(state){
        if (!state.startDate || !state.endDate) {
            return state.indicatorsResults;
        }

        return state.indicatorsResults.filter(item => {
            const itemDate = item.fecha;
            return itemDate >= state.startDate && itemDate <= state.endDate;
        });

    },
    getFullresults(state){
        return state.indicatorsResults; 
    },
    getloadingResults(state){
        return state.loadingResults;
    },
    getDateresults(state){
        return state.dateResults; 
    },
    getloadingDateResults(state){
        return state.loadingDateResults;
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}


